import * as React from 'react';
import { BillingAddress, PaymentDetails } from 'fs-api-client';

interface UserPaymentDetailsProps {
    paymentDetails: PaymentDetails | undefined;
}

export class UserPaymentDetails extends React.Component<UserPaymentDetailsProps> {
    render() {
        if (this.props.paymentDetails && this.props.paymentDetails.billingAddress) {
            return (
                <div>
                    {this.getBillingAddressSectionContent(this.props.paymentDetails.billingAddress)}
                </div>
            );
        }
        return null;
    }

    private getBillingAddressSectionContent(billingAddress: BillingAddress): JSX.Element | null {
        if (!this.props.paymentDetails) {
            return null;
        }
        const description = this.props.paymentDetails.description;
        const billingName = this.props.paymentDetails.name;
        let { line1 = '', line2 = '', city = '', country = '', state = '', postalCode = '' } = billingAddress;
        if (state === null) {
            state = '';
        }
        if (postalCode === null) {
            postalCode = '';
        }
        const name = billingName ? `Billing name: ${billingName}` : `Billing name: ${description}`;
        const address = `${line1}${line2 ? `, ${line2}` : ''} ${city} ${country} ${state} ${postalCode}`;

        return (
            <>
                {name}<br/>
                {`Address: ${address}`}
            </>
        );
    }

}


// WEBPACK FOOTER //
// ./src/backoffice/components/user/UserPaymentDetails.tsx